import { copApi } from 'api'

export interface Props {
  practitionerId: string
}

export const postFavouritePractitioner = ({ practitionerId }: Props) =>
  copApi.post(`/practitioners/${practitionerId}/favourite`)
